import {
  WsEventsManager,
  WsRequestManager,
  WsSubscribeManager,
} from '@gem/modules/wsClient/wsManagers';

import { ProjectUrls } from 'APP/packages/projectUrls/ProjectUrls';

import { WsAppApiController } from './WsAppApiController';
import { wsAppApiNetworkService } from './WsAppApiNetworkService';
import { WsAppLog } from './WsAppLog';

export const wsAppRequestManager = new WsRequestManager(wsAppApiNetworkService);

export const wsAppSubscribeManager = new WsSubscribeManager(wsAppApiNetworkService);
export const wsAppEventsManager = new WsEventsManager(wsAppApiNetworkService);
export const wsAppLog = new WsAppLog(wsAppApiNetworkService);

export const wsAppApiController = new WsAppApiController(
  wsAppApiNetworkService,
  ProjectUrls.wsApiUrl
);
